import React, {useState} from 'react';

import styles from './styles.module.scss';
import {TopElement} from '../TopElement';
import {featuresLinks} from '../../../constants/links';
import {VerificationIcon} from '../../../assets';
import PreviewVerification from '../../dashboard/bodyDashboard/verefication/PreviewVerification';

export const Verification = () => {
  const [selectedValue, setSelectedValue] = useState('Numerical Captcha');

  return (
    <div className={styles.wrapper}>
      <TopElement
        title="Verification"
        subTitle="Bots are prevented from accessing the server by using captcha verification. Themis has two types of captcha - numeric and picture. Furthermore, there are indicators in verification that are triggered by divergent normal user behaviour."
        labelTitle="Verification Tutorial"
        labelLInk={featuresLinks.verivication}
      />
      <div className={styles.block}>
        <div className={styles.content}>
          <VerificationIcon />
          <div className={styles.preview}>
            <PreviewVerification
              selectedValue={selectedValue}
              setSelectedValue={setSelectedValue}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
